import React from "react";
import { LogoVkIcon } from "../../assets/icons/LogoVkIcon";
import styles from "./ButtonVk.module.scss";

export const ButtonVk = () => {
  return (
    <div className={styles.vkButton}>
      <LogoVkIcon />
    </div>
  );
};
